module.exports = __webpack_public_path__ + "img/04bb044.jpg";